export default __webpack_public_path__ + "locales/bg/SendInviteDialog.json?hash=e1b04f5a17930bee67529d73d96f28d4";